import React from "react";
import { RightPart } from "./components/RightPart";
import { LeftPart } from "./components/LeftPart";

export const Notice = () => {
  return (
    <div className="notice-page py-5">
      <div className="container">
        <div className="row">
          <LeftPart />
          <RightPart />
        </div>
      </div>
    </div>
  );
};
